import { render } from "./TroopsInVillages.vue?vue&type=template&id=6a8244e6"
import script from "./TroopsInVillages.vue?vue&type=script&lang=js"
export * from "./TroopsInVillages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/troops/TroopsInVillages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a8244e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a8244e6', __exports__)) {
    api.reload('6a8244e6', __exports__)
  }
  
  module.hot.accept("./TroopsInVillages.vue?vue&type=template&id=6a8244e6", () => {
    api.rerender('6a8244e6', render)
  })

}


export default __exports__